import * as React from 'react';
export const frostSvg = React.forwardRef(function frostSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0F4B92',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm11.87 16.29-6.8 2.8s-.27-.3-.27-1.18c0-.88.75-2.1 2.3-2.06l4.77.44zm.58 1.42L7.4 23.04s-.38-.17-.74-.97a2.16 2.16 0 0 1 1.27-2.82l4.53-1.54zm1.2 1.12-2.47 6.92s-.41 0-1.07-.58a2.16 2.16 0 0 1 .02-3.1l3.51-3.24zm1.59.61.57 7.33s-.38.17-1.22-.1a2.16 2.16 0 0 1-1.24-2.83l1.89-4.4zm1.74-.02 3.5 6.47s-.28.31-1.15.4c-.87.1-2.17-.53-2.3-2.08l-.05-4.79zm1.53-.65 5.83 4.48s-.12.4-.88.84c-.76.43-2.2.4-2.94-.98-.23-.47-2-4.34-2-4.34zm1.17-1.15 7.15 1.72s.05.42-.47 1.13a2.16 2.16 0 0 1-3.08.3l-3.6-3.15zm.47-1.44 7.23-1.33s.2.36.03 1.22a2.16 2.16 0 0 1-2.7 1.53l-4.56-1.42zm-.22-1.47L26 10.56s.34.24.53 1.1c.18.85-.3 2.21-1.84 2.5l-4.75.55zm-.88-1.3 3.84-6.27s.41.08.93.79c.51.71.62 2.15-.66 3.03l-4.11 2.44zm-1.46-.88.97-7.29s.4-.09 1.16.35c.76.44 1.45 1.7.63 3.03l-2.76 3.9zm-1.7-.28L13.8 5.2s.33-.25 1.2-.15c.88.09 2.02.97 1.81 2.51l-.93 4.7zm-1.7.32L9.42 6.98s.2-.36 1.04-.63c.83-.28 2.23.06 2.67 1.56l1.06 4.66zm-1.38.9L6.18 10.3s.04-.41.69-1a2.16 2.16 0 0 1 3.08.34l2.86 3.83zM12 14.8l-7.36-.2s-.13-.4.23-1.2a2.16 2.16 0 0 1 2.95-.94L12 14.8z',
      }),
    ),
  );
});
frostSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var frost = {
  category: 'brand',
  colorable: false,
  name: 'frost',
  svg: frostSvg,
};
